import { Navigate, useParams } from "react-router-dom";
import LayoutPage from "../../Components/LayoutPage";
import NavLayer2 from "../../Components/NavLayer2/NavLayer2";
import Buttons from "./Components/Buttons";
import TransactionsList from "./Components/TransactionsList";
import {
  getTransactionHistoryTab,
  TRANSACTION_HISTORY_DEFAULT_PATH,
  TRANSACTION_HISTORY_TABS,
} from "./transactionHistoryTabs";

export default function Transactions() {
  const { transactionTab } = useParams();
  const activeTab = getTransactionHistoryTab(transactionTab);

  if (!transactionTab || activeTab.key !== transactionTab) {
    return <Navigate to={TRANSACTION_HISTORY_DEFAULT_PATH} replace />;
  }

  return (
    <LayoutPage
      activeIndex={3}
      navItems={["مدیریت تراکنش‌ها"]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-auto"
    >
      <NavLayer2
        texts={TRANSACTION_HISTORY_TABS.map((tab) => tab.label)}
        hrefs={TRANSACTION_HISTORY_TABS.map((tab) => tab.path)}
        activeIndex={TRANSACTION_HISTORY_TABS.findIndex(
          (tab) => tab.key === activeTab.key,
        )}
      />
      <Buttons />
      <TransactionsList key={activeTab.key} tabKey={activeTab.key} />
    </LayoutPage>
  );
}
